import { render, staticRenderFns } from "./staff-radio-group.vue?vue&type=template&id=fd950082&scoped=true"
import script from "./staff-radio-group.vue?vue&type=script&lang=js"
export * from "./staff-radio-group.vue?vue&type=script&lang=js"
import style0 from "./staff-radio-group.vue?vue&type=style&index=0&id=fd950082&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd950082",
  null
  
)

export default component.exports